
import Cache from 'c-cache';

const cache = new Cache({
    prefix: 'webuppay'
});

export default cache;


// WEBPACK FOOTER //
// ./js/global/cache.js